module.exports = __webpack_public_path__ + "img/shaofu.86e453d1.jpg";